import * as yup from 'yup';
import { IAiDataExtractorUploadInput, UserInput } from '../../components/features/Login/interface/interface';

export const userLoginSchema: yup.ObjectSchema<UserInput> = yup.object({
    Username: yup.string().required('Please provide your user name').min(1),
    Password: yup.string().required('Please provide your password').min(8),
});

export const aiDataExtractorUploadInputSchema: yup.ObjectSchema<IAiDataExtractorUploadInput> = yup.object({
    title: yup.string().required('Please provide package title').min(1),
    description: yup.string().required('Please provide package description').min(3).max(1000),
})